// extracted by mini-css-extract-plugin
export var header = "_3v-0";